import React from "react";
import Hero from "./components/hero";

function Home() {
  return (
    <>
      <Hero />
    </>
  );
}

export default Home;
